import { render, staticRenderFns } from "./c2CustomerProfile.vue?vue&type=template&id=bbdfb43a"
import script from "./c2CustomerProfile.vue?vue&type=script&lang=js"
export * from "./c2CustomerProfile.vue?vue&type=script&lang=js"
import style0 from "./c2CustomerProfile.vue?vue&type=style&index=0&id=bbdfb43a&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports